import { generateToggleStageDefs } from './instagramToggleUtils'
import { activityStatusUrl } from './instagramUrls'
import { InstagramSettingKey } from '../../recommendations/recommendationSettingsKeys'
import { InstagramRecommendationKey } from '../../utils/enums'
import {
  defaultCantUndoFn,
  defaultIsDisabledFn,
  defaultIsDisabledReasonFn,
  getCurrentValueFnFromKey,
  getIsFulfilledFnFromKey,
} from '../recommendationCardDisplayUtils'

const saveKey = InstagramSettingKey.STATUS_VISIBILITY
const sectionTitle = 'Show activity status'
const targetValue = false

const getCurrentValueFn = (key) =>
  getCurrentValueFnFromKey(key, (value) => (value ? 'On' : 'Off'))
const getIsFulfilledFn = (key) =>
  getIsFulfilledFnFromKey(key, (value) => !value)
const getCantUndoFn = () => defaultCantUndoFn
const getIsDisabledFn = () => defaultIsDisabledFn
const getIsDisabledReasonFn = () => defaultIsDisabledReasonFn

enum StageKey {
  GATHER_STATUS_VISIBILITY = 'GATHER_STATUS_VISIBILITY',
  UPDATE_STATUS_VISIBILITY = 'UPDATE_STATUS_VISIBILITY',
  UNDO_STATUS_VISIBILITY = 'UNDO_STATUS_VISIBILITY',
}

const { gatherStageDefs, updateStageDefs, undoStageDefs } =
  generateToggleStageDefs(
    InstagramRecommendationKey.INSTAGRAM_STATUS_VISIBILITY,
    [sectionTitle],
    () => saveKey,
    () => targetValue,
    StageKey.GATHER_STATUS_VISIBILITY,
    StageKey.UPDATE_STATUS_VISIBILITY,
    StageKey.UNDO_STATUS_VISIBILITY,
    activityStatusUrl,
  )

export {
  getCantUndoFn,
  getCurrentValueFn,
  getIsDisabledFn,
  getIsDisabledReasonFn,
  getIsFulfilledFn,
  gatherStageDefs,
  updateStageDefs,
  undoStageDefs,
}
